import { useRef } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';

import VideoInfo from 'components/UI/VideoInfo/VideoInfo';

const ShowTrailer = props => {
  const playerRef = useRef(null);

  const videoJsOptions = {
    autoplay: true,
    currentTime: 20,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        src: props.trailerData.hlsMedium
      }
    ]
  };

  const handlePlayerReady = player => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on('waiting', () => {
      // eslint-disable-next-line no-console
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      // eslint-disable-next-line no-console
      console.log('player will dispose');
    });
  };

  return (
    <Dialog
      open={props.openTrailer}
      onClose={props.onClose}
      fullWidth
      maxWidth="lg"
    >
      <VideoInfo
        options={videoJsOptions}
        onReady={handlePlayerReady}
      />
    </Dialog>
  );
};

ShowTrailer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  openTrailer: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  onClose: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  trailerData: PropTypes.bool
};

export default ShowTrailer;
